import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";

const CARD_IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_one-on-one-yoga/artifacts/nqsvjdpa_Screenshot%202026-08-22%20at%2010.09.19.png";

const EASE = [0.22, 1, 0.36, 1];

export const Hero = ({ onNavigate }) => (
  <section
    id="top"
    data-testid="hero-section"
    className="relative min-h-screen flex flex-col items-center justify-center px-6 pt-24 pb-20"
  >
    <motion.div
      initial={{ opacity: 0, y: 28 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.1, delay: 0.15, ease: EASE }}
      className="w-full max-w-md sm:max-w-xl md:max-w-2xl"
    >
      <img
        src={CARD_IMG}
        alt="Ophelia Yoga — private 1:1 yoga classes"
        className="w-full"
        data-testid="hero-logo-card"
      />
      <h1 className="sr-only" data-testid="hero-heading">
        Ophelia Yoga
      </h1>
    </motion.div>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.5, ease: EASE }}
      className="mt-6 md:mt-10 max-w-md text-center text-base sm:text-lg leading-relaxed font-light tracking-wide text-olive-soft"
      data-testid="hero-subtext"
    >
      One-to-one yoga, gently tailored to you — practised in the comfort and
      quiet of your own home. Bath, UK.
    </motion.p>

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.7, ease: EASE }}
      className="mt-10"
    >
      <button
        data-testid="hero-cta-button"
        onClick={() => onNavigate("contact")}
        className="group inline-flex items-center gap-3 rounded-full bg-olive text-cream px-8 py-4 text-sm tracking-[0.14em] uppercase transition-all duration-400 hover:opacity-80 hover:-translate-y-0.5"
      >
        Begin a conversation
        <ArrowDown className="w-4 h-4 transition-transform duration-400 group-hover:translate-y-0.5" />
      </button>
    </motion.div>
  </section>
);
